module.exports = __webpack_public_path__ + "static/media/shakishaki_logo_RVB.11865ce5.png";